var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen"},[(_vm.isLoading)?_c('loading-screen'):_c('div',{staticClass:"h-full"},[(_vm.msTeamsAppInitialized)?_c('router-view'):_c('div',[_vm._v("\n      This route only supported in Microsoft Teams\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }